module.exports = __webpack_public_path__ + "3d6ee524e4fde7b65c1661e3bfc13778.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/states/company/whats-new/update/2024-12-12/whats-new.html
// module id = 2344
// module chunks = 0